import { SurveyComponent } from "@tree-company/tree-query";
import { survey } from "../survey";
import Header from "../components/header";

export default function Survey() {
  return (
    <div className="page">
      <Header />
      <SurveyComponent survey={survey} />
    </div>
  );
}
